import {
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps,
} from "@mui/material";

import { forwardRef, Ref } from "react";

type TextFieldProps = {
  "data-cy": string;
} & MuiTextFieldProps;

export const TextField = forwardRef(
  (textFieldProps: TextFieldProps, ref: Ref<HTMLInputElement>) => {
    const { "data-cy": datacy, ...rest } = textFieldProps;

    return (
      <MuiTextField
        fullWidth
        {...rest}
        slotProps={{
          ...rest.slotProps,
          htmlInput: { "data-cy": datacy, ...rest.slotProps?.htmlInput },
        }}
        inputRef={ref}
      />
    );
  },
);

export default TextField;
